import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: "/",
    class: "blox-up-text"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("Blox", -1),
      _createElementVNode("span", null, "Up", -1)
    ]))]),
    _: 1
  }))
}